/* eslint-disable */
'use strict';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const AnimationOnScroll = {
    init: function() {
        const tube = document.querySelector(".js-tube");
        const gel = document.querySelector(".js-gel");
        const accordionGel = document.querySelector(".js-50-50-accordion .js-gel")
  
        if(tube && gel) {
            // Ensure the gel starts out of view
            gsap.set(gel, { y: accordionGel ? '70%' : '80%' });

            // Create a timeline for the gel animation
            const gelTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ".js-tube-container",
                    start: window.innerWidth < 768 ? "center-=90 center" : "top center",
                    end: "bottom center", // End animation when bottom of container hits center of viewport
                    scrub: true
                }
            });

            gelTimeline.to(gel, {
                y: '10%', // Move gel into view
                ease: "power1.inOut",
            });

            // Create a timeline for the tube animation that follows the gel
            const tubeTimeline = gsap.timeline({
                scrollTrigger: {
                    trigger: ".js-tube-container",
                    start: "top center", // Start animation when top of container hits center of viewport
                    end: "bottom center", // End animation when bottom of container hits center of viewport
                    scrub: true
                }
            });

            tubeTimeline.to(tube, {
                rotation: accordionGel ? -2 : 2 , // Adjust rotation to simulate squeezing
                ease: "power1.inOut",
            })
            .to(tube, {
                rotation: accordionGel ? 2 : -2 ,
                ease: "power1.inOut",
                onComplete: function() {
                    // Reset tube to its initial state
                    gsap.set(tube, { rotation: 0, x: 0 });
                }
            });
        }
    },
};

export default AnimationOnScroll;